import { Badge } from '@mui/joy';

const size = '16px';

// Badge forced to a circle, so single-digit counts don't render as a pill.
export function RoundBadge({ children, ...props }) {
  return (
    <Badge
      size="sm"
      slotProps={{
        badge: {
          sx: {
            width: size,
            height: size,
            minWidth: size,
            minHeight: size,
            fontSize: '10px',
            p: 0,
            borderRadius: '50%',
            lineHeight: 1,
          },
        },
      }}
      {...props}
    >
      {children}
    </Badge>
  );
}
